var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 596.99 220.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffffff;}.cls-2{fill:#3d6bfc;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ativo 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_5",
    "data-name": "Camada 5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "361.62 36.58 288.47 219.46 251.89 219.46 178.74 36.58 219.89 36.58 270.18 162.31 320.47 36.58 361.62 36.58"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "596.99 37.72 523.84 220.6 482.63 220.6 555.84 37.72 596.99 37.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M182.13,143.59A91.64,91.64,0,1,0,0,129.16a92.64,92.64,0,0,0,1.13,14.43,91.65,91.65,0,0,0,155.35,50.32l-26-26a54.83,54.83,0,0,1-91.7-24.28ZM41.59,106.76A55.35,55.35,0,0,1,52.92,90.35a54.83,54.83,0,0,1,88.75,16.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M422.73,163.19a14.23,14.23,0,0,0-.08,1.61,14.64,14.64,0,0,0,.08,1.62,18.14,18.14,0,0,0,18,16.65h18.2v36.1l0,.09H438l-.87-.06a54.9,54.9,0,0,1-50.57-51.85V0h36.19V37.25h36.19V73.44H422.73Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvt);
export default __webpack_public_path__ + "static/media/evt.61e4fe1c9901669bc2160e8d94e8793d.svg";
export { ForwardRef as ReactComponent };